<template>
  <div>
      <b-card style="overflow-x: hidden">
      <template #header>
          <div class="d-flex justify-content-between" style="width: 100%;">
            <h3>NPS</h3>
            <b-dropdown
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            right
            variant="outline-primary"
            text="Export"
            class="mr-3"
            >
              <b-dropdown-item 
                @click="exportToExcel(
                  items,
                  ['NIK', 'Nama', 'Position', 'Division', 'Content', 'Access', 'Benefit', 'Score', 'Comment', 'Date', 'Periode'],
                  ['user_name', 'NAME', 'JABATAN', 'DIVISION', 'rating_content', 'rating_access', 'rating_benefit', 'rating_val', 'rating_comment', 'rating_date', 'periode'],
                  ['NPS Rating'],
                  formatJson
                )"
              >As Excel</b-dropdown-item>
            </b-dropdown>
          </div>
      </template>
    <div class="m-2">
      <b-row>
        <div class="d-flex flex-row flex-wrap row-gap-1 bd-highlight">
          <div>
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block ml-50 mr-1"
            />
          </div>
          <div>
            <label>Year</label>
            <v-select
              v-model="year"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="years"
              class="per-page-selector d-inline-block ml-50 mr-1"
            />
          </div>
          <div>
            <label>Quartal</label>
            <v-select
              v-model="quartal"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="['1', '2', '3', '4']"
              class="per-page-selector d-inline-block ml-50 mr-1"
            />
          </div>
          <div class="d-flex align-items-center">
            <label class="mr-1">Search</label>
            <b-form-input
              placeholder="Search..."
              v-model="searchWord"
            />
          </div>
        </div>
      </b-row>
    </div>
    <div class="d-none d-md-flex">
      <b-table 
        responsive
        :sort-by.sync="sortBy" 
        :sort-desc.sync="sortDesc" 
        :items="items" 
        :fields="fields" 
        :no-local-sorting="true" 
        :filter="searchWord"
        :filter-function="customFilter"
        @sort-changed="sortingChanged"
        :busy="isBusy"
      >
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle mr-1" variant="secondary"></b-spinner>
            <strong class="text-secondary">Loading...</strong>
          </div>
        </template>
        <template #cell(rating_val)="data">
          <span
            v-b-tooltip.hover.html
            :title="`
              Content: ${data.item.rating_content}<br>
              Benefit: ${data.item.rating_benefit}<br>
              Access: ${data.item.rating_access}
            `"
          >
            {{ data.item.rating_val }}
          </span>
        </template>
        <template #cell(periode)="data">
          <div> Q{{ getQuartal(data.item.rating_date) }} - {{ getYear(data.item.rating_date) }} </div>
        </template>
        <template #cell(rating_date)="data">
          <div> {{$moment(data.value).format("YYYY[-]M[-]D") }} </div>
        </template>
      </b-table>
    </div>
    <div class="d-flex d-md-none flex-column">
      <div v-if="isBusy" class="text-center text-danger my-2">
        <b-spinner class="align-middle mr-1" variant="secondary"></b-spinner>
        <strong class="text-secondary">Loading...</strong>
      </div>
      <div v-if="!isBusy && items.length == 0" class="text-center text-danger my-2">
        <strong class="text-secondary">No data</strong>
      </div>
      <b-row
        v-if="!isBusy && items.length > 0"
        v-for="(item, index) in items"
        :key="item.id"
        class="mb-3 list-item"
      >
        <b-col cols="12" class="d-flex flex-wrap justify-content-end align-items-center mb-1" style="gap: 1rem;">
          <strong class="flex-grow-1 truncate">{{ item.user_name }}</strong>
        </b-col>
        <b-col cols="12" class="d-flex flex-wrap">
          <div style="font-size: 0.75rem;">
            <p><strong>NAMA:</strong> {{ item.NAME || '-' }}</p>
            <p><strong>POSITION:</strong> {{ item.JABATAN || '-' }}</p>
            <p><strong>DIVISION:</strong> {{ item.DIVISION }}</p>
            <p><strong>SCORE:</strong> {{ item.rating_val }}</p>
            <p><strong>COMMENT:</strong> {{ item.rating_comment }}</p>
            <p><strong>DATE:</strong> {{ $moment(item.rating_date).format("YYYY[-]M[-]D") }}</p>
            <p><strong>PERIODE:</strong> {{ 'Q' +  getQuartal(item.rating_date) + ' - ' + getYear(item.rating_date) }}</p>
          </div>
        </b-col>
      </b-row>
    </div>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">Showing {{ currentPage * perPage - perPage + 1 }} to {{ currentPage * perPage - perPage + showData  }} of {{ totalData }} entries</span>
            </b-col>
            <b-col
              v-if="perPage !== 'all'" 
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalData"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
                @input="inputPagination"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>

            </b-col>

          </b-row>
        </div>
      </b-card>
      <vue-html2pdf
          :show-layout="false"
          :float-layout="true"
          :enable-download="true"
          :preview-modal="false"
          :paginate-elements-by-height="1400"
          filename="NPS Rating"
          :pdf-quality="2"
          :manual-pagination="false"
          pdf-format="a4"
          pdf-orientation="landscape"
          pdf-content-width="800px"
          @progress="onPDFProgress($event)"
          @hasStartedGeneration="hasStartedGeneration()"
          @hasGenerated="hasGenerated($event)"
          ref="html2Pdf"
      >
          <section slot="pdf-content">
            <b-table 
              :sort-by.sync="sortBy" 
              :sort-desc.sync="sortDesc" 
              :items="items" 
              :fields="fields" 
              :no-local-sorting="true" 
              @sort-changed="sortingChanged"
              :busy="isBusy"
              :filter-function="customFilter"
            >
              <template #cell(periode)="data">
                <div> Q{{ getQuartal(data.item.rating_date) }} - {{ getYear(data.item.rating_date) }} </div>
              </template>
              <template #cell(rating_date)="data">
                <div> {{$moment(data.value).format("YYYY[-]M[-]D") }} </div>
              </template>
            </b-table>
          </section>
      </vue-html2pdf>
      <table-summary />
  </div>
</template>
<script>
import {
  BCard, BCardText, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination, BTooltip, BSpinner, BFormCheckbox, BModal, BImg, VBTooltip
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import VueHtml2pdf from 'vue-html2pdf'
import axios from '@/libs/axios'
import TableSummary from './tableSummary.vue'
import { generateToken } from '@/auth/helperAuth'

export default {
  components: {
    BCard,
    BCardText,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    BSpinner,
    BFormCheckbox,
    BModal,
    BImg,

    vSelect,
    VueHtml2pdf,

    'table-summary': TableSummary,
  },
  data() {
    return {
      token: '',
      perPage: '10',
      perPageOptions: ['10', '20', '30', '50', '100', '500', '1000', 'all'],
      years : [],
      currentPage: 1,
      totalData: 200,
      showData: 0,
      items: [],
      sortBy: 'rating_date',
      sortDesc: true,
      searchWord: '',
      isBusy: false,

      selectedItem: {
        icon: '',
        icon_details: {}
      },
      year: 'All',
      quartal: '',
    }
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  created() {
    const payload = {
      client: "product-catalog-fe",
      kode: this.$store.getters['oauth/getActiveUser'].id.toString(),
      user: this.$store.getters['oauth/getActiveUser'].name,
      role: this.$store.getters['oauth/getActiveUser'].role,
    }
    this.token = generateToken(payload)
  },
  computed: {
    skip() {
      if (Number.isNaN(parseInt(this.perPage))) {
        return 0
      }
      return this.perPage * (this.currentPage - 1)
    },
    imgSelectedItem() {
      return typeof this.selectedItem.icon_details === 'object' && typeof this.selectedItem.icon_details.original === 'object' ? this.selectedItem.icon_details.original.url : ''
    },
    isAdminOrApprover() {
      let roles = this.$store.getters['oauth/getActiveUser'].role
      if (roles.includes('approver') || roles.includes('admin')) {
        return true
      }
      return false
    },
    fields() {
      let toShow = [
        { key: 'user_name', label: 'NIK', sortable: true},
        { key: 'NAME', label: 'Nama', sortable: false},
        { key: 'JABATAN', label: 'Position', sortable: false},
        { key: 'DIVISION', label: 'Division', sortable: false},
        { key: 'rating_val', label: 'Score', sortable: true},
        { key: 'rating_comment', label: 'Comment'},
        { key: 'rating_date', label: 'Date', sortable: true},
        'Periode',
      ]
      return toShow
    }
  },
  watch: {
    perPage() {
      this.getNPS()
    },
    currentPage() {
      this.getNPS()
    },
    year() {
      this.currentPage = 1
      this.getNPS()
    },
    quartal() {
      this.currentPage = 1
      this.getNPS()
    },
    searchWord(val) {
      this.currentPage = 1
      const v = (val || '').trim()
      const isNumber = /^\d+([.,]\d+)?$/.test(v)
      const digitsOnly = v.replace(/\D/g, '')
      if (v === '') {
        this.getNPS()
        return
      }
      if (isNumber && digitsOnly.length >= 4) {
        this.getNPS()
        return
      }
      this.$store.dispatch('app/search', {
        callback: () => {
          this.getNPS()
        }
      })
    }
  },
  mounted() {
    this.fetchYears()
    this.getNPS()
  },
  methods: {
    sortingChanged(ctx) {
      this.sortBy = ctx.sortBy
      this.sortDesc = ctx.sortDesc
      this.getNPS()
    },
    async fetchYears(){
      return await axios.post('/rating/fetchYear', {
        res: null
      })
      .then(res => {
        res.data.unshift('All')
        this.years = res.data
      })
      .catch(err => console.error(err))
      .finally()
    },
    customFilter(row, filter) {
      if (!filter) return true
      const fRaw = filter.toString().trim()
      const f = fRaw.toLowerCase().replace(',', '.')
      const isNumber = /^\d+(\.\d+)?$/.test(fRaw)
      const digitsOnly = fRaw.replace(/\D/g, '')

      if (isNumber && digitsOnly.length >= 4) {
        return Object.keys(row).some(key => {
          const val = row[key]
          if (val == null) return false
          return val.toString().toLowerCase().includes(f)
        })
      }
      if (isNumber) {
        const rowScoreStr = (typeof row.rating_val !== 'undefined' && row.rating_val !== null)
          ? Number(row.rating_val).toFixed(2)
          : ''
        if (rowScoreStr.includes(f)) return true
        const keysToCheck = ['rating_content', 'rating_access', 'rating_benefit']
        for (const k of keysToCheck) {
          const v = row[k]
          if (v != null && v.toString().toLowerCase().includes(f)) return true
        }
        return false
      }

      return Object.keys(row).some(key => {
        const val = row[key]
        if (val == null) return false
        return val.toString().toLowerCase().includes(f)
      })
    },
    async getNPS() {
      let searchWord  = this.searchWord.trim()
      let base = '/rating/with.total/true'
      let take = `/take/${this.perPage}`
      let skip = `/skip/${this.skip}`
      let search = `${searchWord !== '' ? `/s/${searchWord}`: ''}`
      let year = `${this.year !== '' ? `/year/${this.year}`: ''}`
      let quartal = `${this.quartal !== '' ? `/quartal/${this.quartal}`: ''}`
      let orderBy = `/orderBy.${this.sortBy}/${this.sortDesc === true ? 'desc' : 'asc'}`
      let complete = base + take + skip + search + orderBy + year + quartal
      this.isBusy = true
      return await this.$http.get(complete)
      .then( res => {
        let list = res.data.data.records.map(dt => {
          console.log(dt)
          return {
            ...dt,
            // rating_date:formatDate(dt.rating_date),
            DIVISION: dt.user_details ? dt.user_details.DIVISION : '',
            NAME: dt.user_details ? dt.user_details.NAME : '',
            JABATAN: dt.user_details ? dt.user_details.JABATAN : '',
          }
        })
        this.items = list
        this.totalData = res.data.data.total
        this.showData = res.data.data.show
      })
      .catch( err => {
        console.error(err)
      })
      .finally(() => {
        this.isBusy = false
      })
    },
    deleteNPS(id) {
      return this.$http.delete(`/rating/${id}`)
        .then(() => {
          this.$notif('Success', 'Rating has been successfully deleted.', 'success')
        })
        .catch(err => {
          let message = ''
          if (typeof err.data.errors === 'object') {
              message = err.data.errors[Object.keys(err.data.errors)[0]][0]
          } else if (typeof err.data.exception === 'object') {
              message = err.data.exception.message
          }
          this.$notif('Something Error', message , 'danger')
        })
        .catch( err => {
          console.error(err)
        })
    },
    inputPagination(page) {
      this.currentPage = page
      if (this.sortBy === 'rating_val' && this._allItems) {
        const start = (this.currentPage - 1) * Number(this.perPage)
        const end   = start + Number(this.perPage)

        this.items = this.perPage === 'all'
          ? this._allItems
          : this._allItems.slice(start, end)

        this.showData = this.items.length
      } else {
        this.getNPS()
      }
    },
    generateTipe(score) {
      if (score > 8) {
        return "Promoter"
      } else if (score < 7) {
        return "Detractors"
      } else {
        return "Passives"
      }
    },
    async exportToExcel(records, headers, fieldVal, filename, formatJson) {
      let searchWord  = this.searchWord.trim()
      let base = '/rating/with.total/true'
      let take = `/take/${this.totalData}`
      let skip = `/skip/0`
      let search = `${searchWord !== '' ? `/s/${searchWord}`: ''}`
      let year = `${this.year !== '' ? `/year/${this.year}`: ''}`
      let quartal = `${this.quartal !== '' ? `/quartal/${this.quartal}`: ''}`
      let orderBy = `/orderBy.${this.sortBy}/${this.sortDesc === true ? 'desc' : 'asc'}`
      let complete = base + take + skip + search + orderBy + year + quartal

      this.isBusy = true
      return await this.$http.get(complete)
        .then(res => {
          import('@/libs/Export2Excel').then(excel => {
            const list = res.data.data.records.map(dt => {
              return {
                ...dt,
                rating_val:dt.rating_val,
                rating_periode: dt.rating_periode,
                rating_date: dt.rating_date,
                rating_content: dt.rating_content,
                rating_access: dt.rating_access,
                rating_benefit: dt.rating_benefit,
                rating_comment: dt.rating_comment,
                DIVISION: dt.user_details ? dt.user_details.DIVISION : '',
                NAME: dt.user_details ? dt.user_details.NAME : '',
                JABATAN: dt.user_details ? dt.user_details.JABATAN : '',
              }
            })

            const data = formatJson(fieldVal, list)
            excel.export_json_to_excel({
              header: headers,
              data,
              filename,
              autoWidth: true,
              bookType: 'xlsx'
            })
          })
        })
        .catch(err => {
          console.error(err)
        })
        .finally(() => {
          this.isBusy = false
        })
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        let data = v[j]
        if (j === 'rating_date') {
          data = this.$moment(v[j]).format("YYYY[-]M[-]D")
        }
        if (j === 'periode') {
          data = `Q${this.getQuartal(v['rating_date'])} - ${this.getYear(v['rating_date'])}`
        }
        return data
      }))
    },
    generateReport () {
        this.$refs.html2Pdf.generatePdf()
    },
    onPDFProgress(event) {
    },
    hasStartedGeneration() {},
    hasGenerated (event) {},
    getMonth(date) {
      return 1 + this.$moment(date).month()
    },
    getQuartal(date) {
      return Math.ceil(this.getMonth(date) / 3)
    },
    getRatingScore(dt) {
      let score = (dt.rating_content + dt.rating_benefit + dt.rating_access) / 3
      return score.toFixed(2)
    },
    getYear(date) {
      return this.$moment(date).year()
    },
    showMsgBoxDelete(item) {
      this.$bvModal
        .msgBoxConfirm('Please confirm that you want to delete this item.', {
          title: 'Please Confirm',
          size: 'sm',
          okVariant: 'danger',
          okTitle: 'Yes',
          cancelTitle: 'No',
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        })
        .then(value => {
          if (value) {
            this.deleteNPS(item.id_rating).then(this.getNPS)
          }
        })
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>